import { Button, FormField, Text } from '@wix/design-system'
import { PublicSmall } from '@wix/wix-ui-icons-common'
import { publishComponent } from '../utils/api'
import React from 'react';

export default function SettingsPublishSection() {
    const [showSuccess, setShowSuccess] = React.useState(false);

    const handlePublish = async () => {
        await publishComponent();
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);
    }

    return (
        <>
            <hr className='mt-2' />
            <div className='section'>
                <FormField label="Publish Settings">
                    <p><Text weight='thin'>Settings are normally published with the whole site, but you can use this button to only publish component settings</Text></p>
                    <div>
                        <Button onClick={handlePublish} prefixIcon={<PublicSmall />} >Publish</Button>
                    </div>
                    {showSuccess && <p className='mt-1'><Text weight='thin' skin='success'>Settings published successfully!</Text></p>}
                </FormField>
            </div>
        </>
    )
}
